const addAnalyticSanitize = (text = ""): string => text
	.toLowerCase()
	.trim()
	.normalize("NFD")
	.replace(/[\u0300-\u036f]/g, "")
	.replace(/[&/\\#,+()$~%.'":*?<>{}!@]/g, "")
	.replace(/\s/g, "-");

export default addAnalyticSanitize;
